// extracted by mini-css-extract-plugin
module.exports = {"floatLabel":"floatLabel_floatLabel__IqJkQ","label":"floatLabel_label__1O3j6","labelFloat":"floatLabel_labelFloat__3fT0t"};